<template>
  <a-modal v-model="modal" title="叫料确认订单" width="90%" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <ls-table-layout>
      <template v-slot:table>
        <div class="page-header-content">
          <a-form-model ref="baseForm" class="baseForm" :model="formData">
            <ls-metable
              class="orderMaterialTable"
              :columns="columns"
              :data-list="formData.infos"
              :scroll="{y:400, x:1600}"
              :customRow="(record, index) => index"
              rowKey="key_id"
              size="middle"
              :loading="tableLoading"
              :IsEdit="false"
              :needAdd="false"
            >
              <!--叫料量-->
              <template slot="callQty" slot-scope="{text,record,index}">
                <a-form-model-item :prop="`infos.${index}.callQty`">
                  <a-input-number
                    v-model="record.callQty"
                    :min="0"
                    :max="Number(record.canCallQty || 0)"
                    :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                    :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')" />
                </a-form-model-item>
              </template>
              <!--叫料期望交货日期-->
              <template #callExpectedDeliveryDateTitle>
                <span>叫料期望交货日期</span>
                <a-icon
                  class="action-icon"
                  type="edit"
                  title="批量编辑"
                  @click.stop="handleBatchEditCallExpectedDeliveryDate"
                />
              </template>
              <template slot="callExpectedDeliveryDate" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.callExpectedDeliveryDate`">
                  <a-date-picker style="width: 100%" v-model="record.callExpectedDeliveryDate" valueFormat="YYYY-MM-DD 00:00:00" :disabledDate="disabledDate" />
                </a-form-model-item>
              </template>
            </ls-metable>
          </a-form-model>
        </div>
      </template>
    </ls-table-layout>
    <template #footer>
      <a-space>
        <a-button @click="onClose">取消</a-button>
        <a-button type="primary" @click="onSubmit" :loading="loading">确定</a-button>
      </a-space>
    </template>
    <batch-edit-call-expected-delivery-date-modal
      ref="batchEditDateModalRef"
      @confirm="handleBatchDateConfirm"
    />
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiMesQueryTradeOrderFromScm,
  apiMesQueryTradeOrderPushToScm
} from '@/api/scp/purchase/purchaseApi'
import BatchEditCallExpectedDeliveryDateModal from './batchEditCallExpectedDeliveryDateModal.vue'

export default {
  name: 'PushMaterialModal',
  components: {
    BatchEditCallExpectedDeliveryDateModal
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      modal: false,
      formData: { infos: [] },
      tableLoading: false, // table加载
      loading: false,
      // 表格字段
      columns: [
        { title: '叫料单号', dataIndex: 'callDocNumber', width: 100, align: 'center' },
        { title: '工单号', dataIndex: 'wipEntityName', width: 110, align: 'center' },
        { title: '物料编码', dataIndex: 'itemCode', width: 120, align: 'center' },
        { title: '需求数量', dataIndex: 'workOrderDemandQty', width: 90, align: 'center' },
        { title: '规格描述', dataIndex: 'specificationDescription', width: 120, ellipsis: true, align: 'center' },
        { title: '物料名称', dataIndex: 'itemName', width: 120, align: 'center' },
        {
          customTitle: '叫料期望交货日期',
          dataIndex: 'callExpectedDeliveryDate',
          scopedSlots: {
            customRender: 'callExpectedDeliveryDate',
            title: 'callExpectedDeliveryDateTitle'
          },
          width: 130,
          align: 'center'
        },
        { title: '交易单号', dataIndex: 'tradeOrder', width: 110, align: 'center' },
        { title: '销售方', dataIndex: 'factoryName', width: 110, align: 'center' },
        { title: '采购数量', dataIndex: 'procurementQuantity', width: 85, align: 'center' },
        {
          title: '订单期望到货日期',
          dataIndex: 'orderExpectedDeliveryDate',
          width: 85,
          align: 'center',
          customRender: (value, row) => row.orderExpectedDeliveryDate ? this.$moment(row.orderExpectedDeliveryDate).format('YYYY-MM-DD') : ''
        },
        { title: '订单可叫料数量', dataIndex: 'canCallQty', width: 90, align: 'center' },
        { title: '叫料数量', dataIndex: 'callQty', scopedSlots: { customRender: 'callQty' }, width: 100, align: 'center' }
      ]
    }
  },
  methods: {
    handleBatchEditCallExpectedDeliveryDate() {
      if (!this.formData.infos.length) {
        this.$message.warning('暂无可编辑数据')
        return
      }
      this.$refs.batchEditDateModalRef.show()
    },
    handleBatchDateConfirm(date) {
      this.formData.infos.forEach(item => {
        this.$set(item, 'callExpectedDeliveryDate', date)
      })
    },
    disabledDate(current) {
      return current && current < this.$moment().startOf('day')
    },
    // 编辑-保存
    onSubmit () {
      // 交期和数量都填了值的，才作为入参
      const params = this.formData.infos.filter(item => item.callExpectedDeliveryDate && (item.callQty === 0 || !!item.callQty))
      if(params?.length < 1) {
        this.$message.error('请填写数据')
        return false
      }
      this.loading = true;
      apiMesQueryTradeOrderPushToScm(params).then(res => {
        if (res?.code === 200) {
          this.$message.success('下推成功')
          this.onClose()
          this.$emit('closeModal')
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    onClose() {
      this.formData.infos = []
      this.modal = false
    },
    // 初始化查询
    show(selectData) {
      this.formData.infos = []
      this.onSearch(selectData)
      this.modal = true
    },
    // 表单搜索
    onSearch (params) {
      this.formData.infos = []
      this.tableLoading = true;
      this.loading = true;
      apiMesQueryTradeOrderFromScm(params).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.formData.infos = res.data.map(item => ({
            ...item,
            callExpectedDeliveryDate: item.orderExpectedDeliveryDate
              ? this.$moment(item.orderExpectedDeliveryDate).format('YYYY-MM-DD 00:00:00')
              : undefined
          }))
        }
      }).finally(() => {
        this.tableLoading = false;
        this.loading = false;
      })
    }
  },
  mounted () {
    this.loading = false;
    this.tableLoading = false;
  }
}
</script>

<style lang="less" scoped>
.orderMaterialTable{
  /deep/ .ant-form-item{
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}
.action-icon{
  margin-left: 6px;
  color: #0486fe;
  cursor: pointer;
  font-size: 14px;
}

</style>
